import { render, staticRenderFns } from "./ChangeRoleView.vue?vue&type=template&id=3615f3d7&scoped=true"
import script from "./ChangeRoleView.vue?vue&type=script&lang=js"
export * from "./ChangeRoleView.vue?vue&type=script&lang=js"
import style0 from "./ChangeRoleView.vue?vue&type=style&index=0&id=3615f3d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3615f3d7",
  null
  
)

export default component.exports